import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';

import { filter, map } from 'rxjs';

import { ROUTES } from '@/app/shared/util-common/navigation/routes.constants';
import { getSiteIdFromUrl } from '@/app/shared/util-user/site-context.utils';
import { UserContextState } from '@/app/shared/util-user/user-context._state';

export const SiteSelectionGuard: CanMatchFn = () => {
  const userContextState = inject(UserContextState);
  const router = inject(Router);

  const isSiteContextLoading$ = toObservable(userContextState.isSiteContextLoading);

  return isSiteContextLoading$.pipe(
    filter((isLoading) => !isLoading),
    map(() => {
      const isSiteIdValid = userContextState
        .availableSites()
        .find(({ siteId, invalid }) => siteId === getSiteIdFromUrl() && !invalid);
      if (isSiteIdValid) {
        return router.createUrlTree([ROUTES.HOME]);
      }

      const isZeroSitesAvailable = !userContextState.availableSites().length;
      if (isZeroSitesAvailable) {
        return router.createUrlTree([ROUTES.ERROR.ERROR, ROUTES.ERROR.CONTEXT_ERROR]);
      }

      const isTheOnlyAvailableSiteValid =
        userContextState.availableSites().length === 1 && !userContextState.someInvalidSites();
      if (isTheOnlyAvailableSiteValid) {
        userContextState.switchSite(userContextState.availableSites()[0]);
        return false;
      }

      return true;
    }),
  );
};
